function PhoneNumberFormatter(value){
    const cleaned = value.replace(/\D/g, "").slice(0, 10); // remove non-digits, max 10 digits
    const match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
    if (!match) return value;
    const [, part1, part2, part3] = match;
    if (part3) return `(${part1}) ${part2}-${part3}`;
    if (part2) return `(${part1}) ${part2}`;
    if (part1) return `(${part1}`;
    return "";
};

export default PhoneNumberFormatter